import { FormControlLabel, Checkbox } from '@mui/material';
import { NotificationCheckboxProps } from './NotificationCheckbox.types';

export const NotificationCheckbox = ({
  name,
  label,
  checked,
  disabled,

  onSendChange
}: NotificationCheckboxProps) => {
  return (
    <FormControlLabel
      control={<Checkbox name={name} checked={checked} disabled={disabled} onChange={onSendChange} />}
      label={label}
    />
  );
};
